import React from 'react';
import { ContentMaps } from '../../../../api/models/BibleStudy';
import { images } from '../../../../assets/images';
import { HorizontalContent } from '../../../core/HorizontalContent';
import { RhButton, RhButtonMode } from '../../../core/RhButton';
import { RhCard } from '../../../core/RhCard';
import { SizedBox } from '../../../core/SizedBox';
import { H2, H5 } from '../../../core/Styles';

interface GuidedContentCardProps {
  contentMaps: ContentMaps;
  onEdit?: () => void;
}

export const GuidedContentCard = (props: GuidedContentCardProps) => {
  return (
    <RhCard mode="tiled">
      <HorizontalContent
        left={<H2>Content Map</H2>}
        right={props.onEdit ? <RhButton mode={RhButtonMode.text} title="Edit" onClick={props.onEdit} /> : null}
      />
      <SizedBox height={12} />
      <H5>{props.contentMaps.length} weeks</H5>
      <SizedBox height={6} />
      <div style={{ maxHeight: 240, overflowY: 'scroll', paddingRight: 16 }}>
        {props.contentMaps.map(item => {
          return (
            <div
              key={`week_${item.week}`}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                background: `url(${images.dot}) repeat-x center`,
                marginBottom: 4,
              }}>
              <div style={{ background: 'white' }}>Week {item.week}</div>
              <div style={{ background: 'white' }}>{item.days} days</div>
            </div>
          );
        })}
      </div>
    </RhCard>
  );
};
